// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./free-damm-0.jpg')
const allTwoEs = require('./static-es.png')
const allTwoCa = require('./static-ca.png')
const allFourEs = require('./static-es.png')
const allFourCa = require('./static-ca.png')
const catalogTwoEs = require('./static-es.png')
const catalogTwoCa = require('./static-ca.png')
const catalogFourEs = require('./static-es.png')
const catalogFourCa = require('./static-ca.png')

const model = creativityMediaModel({
  catalogID: 'beer',
  allTwoEs,
  allTwoCa,
  allFourEs,
  allFourCa,
  catalogTwoEs,
  catalogTwoCa,
  catalogFourEs,
  catalogFourCa
})

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) =>
    model[params.catalogID][params.numberOfColumns][params.language]
}
